import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyUs from './components/WhyUs';
import Partners from './components/Partners';
import ContactForm from './components/ContactForm';
import About from './components/About';
import CookieBanner from './components/CookieBanner';
import ScrollProgressNavigation from './components/ScrollProgressNavigation';
import VisitorMonitor from './components/VisitorMonitor';
import AdminPanel from './components/AdminPanel';
import './App.css';

const BACKEND = 'https://crm-backend-6jqe.onrender.com';

function App() {
  useEffect(() => {
    // Zalogovat návštěvu jednou za session (přeskočit admin/monitor stránky)
    if (sessionStorage.getItem('visit_logged')) return;
    if (window.location.pathname === '/admin' || window.location.pathname === '/monitor') return;
    sessionStorage.setItem('visit_logged', '1');
    fetch(`${BACKEND}/api/visits`, { method: 'POST' }).catch(() => {});
  }, []);

  return (
    <Router>
      <div className="App min-h-screen bg-white text-gray-900">
        {/* Pro partnery Button */}
        <div className="fixed top-4 right-4 z-50">
          <a
            href="https://www.crm.vyjedname.cz/#/"
            target="_blank"
            rel="noopener noreferrer"
            className="px-4 py-2 rounded-full shadow-md text-sm font-medium bg-white/90 border border-gray-200 text-gray-700 hover:text-red-600 hover:bg-white hover:shadow-lg backdrop-blur-md transition-all duration-300 hover:scale-105"
            style={{ backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)' }}
          >
            Pro partnery
          </a>
        </div>

        <Routes>
          <Route path="/" element={
            <>
              <ScrollProgressNavigation />
              <Hero />
              <Services />
              <WhyUs />
              <Partners />
              <ContactForm />
              <About />
              <CookieBanner />
            </>
          } />
          <Route path="/monitor" element={<VisitorMonitor />} />
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
